namespace Gamification.Gamification {
    export interface RisorseForm {
        IdRisorsa: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
        TenantId: Serenity.IntegerEditor;
        IdTipologiaRisorsa: Serenity.LookupEditor;
        IdEstensione: Serenity.LookupEditor;
        IdTipologiaCaricamento: Serenity.LookupEditor;
        IdentifierRisorsa: Serenity.StringEditor;
        Nome: Serenity.StringEditor;
        VersioneAssetBundle: Serenity.IntegerEditor;
        Descrizione: Serenity.TextAreaEditor;
        Escludi: Serenity.BooleanEditor;
        UrlAssetBundle: Serenity.StringEditor;
        IsUrlAssetBundleEsterno: Serenity.BooleanEditor;
        NomeFileAssetBundle: Serenity.StringEditor;
        PathFileAssetBundle: Serenity.ImageUploadEditor;
        UrlCoverAssetBundle: Serenity.StringEditor;
        IsUrlCoverAssetBundleEsterno: Serenity.BooleanEditor;
        NomeFileCoverAssetBundle: Serenity.StringEditor;
        PathFileCoverAssetBundle: Serenity.ImageUploadEditor;
        UrlManifestAssetBundle: Serenity.StringEditor;
        IsUrlManifestAssetBundleEsterno: Serenity.BooleanEditor;
        NomeFileManifestAssetBundle: Serenity.StringEditor;
        PathFileManifestAssetBundle: Serenity.ImageUploadEditor;
        AssetPath: Serenity.StringEditor;
        AssetEsperienzeList: AssetEsperienzeRisorse2Editor;
        ProdottiList: ProdottiRisorse2Editor;
    }

    export class RisorseForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.Risorse';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RisorseForm.init)  {
                RisorseForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.TextAreaEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.ImageUploadEditor;
                var w6 = AssetEsperienzeRisorse2Editor;
                var w7 = ProdottiRisorse2Editor;

                Q.initFormType(RisorseForm, [
                    'IdRisorsa', w0,
                    'UserId', w0,
                    'TenantId', w0,
                    'IdTipologiaRisorsa', w1,
                    'IdEstensione', w1,
                    'IdTipologiaCaricamento', w1,
                    'IdentifierRisorsa', w2,
                    'Nome', w2,
                    'VersioneAssetBundle', w0,
                    'Descrizione', w3,
                    'Escludi', w4,
                    'UrlAssetBundle', w2,
                    'IsUrlAssetBundleEsterno', w4,
                    'NomeFileAssetBundle', w2,
                    'PathFileAssetBundle', w5,
                    'UrlCoverAssetBundle', w2,
                    'IsUrlCoverAssetBundleEsterno', w4,
                    'NomeFileCoverAssetBundle', w2,
                    'PathFileCoverAssetBundle', w5,
                    'UrlManifestAssetBundle', w2,
                    'IsUrlManifestAssetBundleEsterno', w4,
                    'NomeFileManifestAssetBundle', w2,
                    'PathFileManifestAssetBundle', w5,
                    'AssetPath', w2,
                    'AssetEsperienzeList', w6,
                    'ProdottiList', w7
                ]);
            }
        }
    }
}
